import { inject, Injectable, Provider } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { ProductIdentifierDto } from '../../INTEGRA_Shop_Client';
import { IProductCompareService, IProductCompareServiceToken } from './product-compare-service.interface';
import { ILoggerService, ILoggerServiceToken } from '../logger/logger-service.interface';
import { IComparisonService, IComparisonServiceToken } from '../comparison/comparison-service.interface';

@Injectable({
  providedIn: 'root'
})
export class ProductCompareService implements IProductCompareService {
  private readonly logger: ILoggerService;
  private readonly comparisonService: IComparisonService;

  private productIdentifierList: ProductIdentifierDto[];

  private productIdentifierListSource: ReplaySubject<ProductIdentifierDto[]> = new ReplaySubject(1);
  private productIdentifierListChanged: Observable<ProductIdentifierDto[]> = this.productIdentifierListSource.asObservable();

  constructor() {
    this.logger = inject(ILoggerServiceToken);
    this.comparisonService = inject(IComparisonServiceToken);

    this.productIdentifierList = [];
    this.productIdentifierListSource.next(this.productIdentifierList);
  }

  public compareListContainsProductIdentifier(productIdentifierDto: ProductIdentifierDto): boolean {
    let matchingProductIdentifier = this.productIdentifierList.find(
      knownProduct => this.comparisonService.equalsProductIdentifierByNumberOrGuid(knownProduct, productIdentifierDto)
    );

    let containsProductIdentifier = matchingProductIdentifier != null;
    return containsProductIdentifier;
  }

  public productIdentifierListChangeGet(): Observable<ProductIdentifierDto[]> {
    return this.productIdentifierListChanged;
  }

  public productAdd(productIdentifier: ProductIdentifierDto): boolean {
    return this.productListAdd([productIdentifier]);
  }

  public productListAdd(productIdentifierList: ProductIdentifierDto[]): boolean {
    if (productIdentifierList.length == 0) {
      this.logger.info("No identifier in product camparison add provided.", this.constructor.name);
    }

    let listChanged: boolean = false;

    productIdentifierList.forEach(
      (productIdentifier: ProductIdentifierDto) => {
        let knownProductIdentifier = this.productIdentifierList.find(
          knownProductIdentifier => this.comparisonService.equalsProductIdentifierByNumberOrGuid(knownProductIdentifier, productIdentifier)
        );

        if (knownProductIdentifier) {
          return;
        } else {
          this.productIdentifierList.push(productIdentifier);
          listChanged = true;
        }
      }
    );

    if (listChanged) {
      this.productIdentifierListSource.next(this.productIdentifierList);
      return true;
    } else {
      return false;
    }
  }

  public productRemove(productIdentifier: ProductIdentifierDto): boolean {
    return this.productListRemove([productIdentifier]);
  }

  public productListRemove(productIdentifierList: ProductIdentifierDto[]): boolean {
    if (productIdentifierList.length == 0) {
      this.logger.info("No identifier in product camparison remove provided.", this.constructor.name);
    }

    let listChanged: boolean = false;

    productIdentifierList.forEach(
      (productIdentifier: ProductIdentifierDto) => {
        let index = this.productIdentifierList.findIndex(
          knownProductIdentifier => this.comparisonService.equalsProductIdentifierByNumberOrGuid(knownProductIdentifier, productIdentifier)
        );

        if (index >= 0) {
          this.productIdentifierList.splice(index, 1);
          listChanged = true;
        }
      }
    );

    if (listChanged) {
      this.productIdentifierListSource.next(this.productIdentifierList);
      return true;
    } else {
      return false;
    }

  }

  public productListSet(productIdentifierList: ProductIdentifierDto[]): void {
    this.productIdentifierList = productIdentifierList;
    this.productIdentifierListSource.next(productIdentifierList);
  }

  public productListClear(): void {
    this.productIdentifierList = [];
    this.productIdentifierListSource.next([]);
  }
}

/**
 * Prepared provider with the token to implementation mapping.
 * Reference this at the desired provider list to enable the injection of this implementation by referencing the token(interface).
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const ProductCompareServiceProvider: Provider =
  { provide: IProductCompareServiceToken, useExisting: ProductCompareService };
